import React, { useEffect, useState } from 'react';
import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import UserTable from './user-table/user-table.component';
import CreateUser from './user/create-user/create-user.component';
import DeleteUser from './user/delete-user/delete-user.component';
import EditUser from './user/edit-user/edit-user.component';
import UserDetails from './user/user-details/user-details.component';
import { set_create_user_drawer } from 'Store/reducers/adminReducer';

const Admin: React.FC = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const { tab } = params;

  useEffect(() => {
    if (tab && selectedTab === null) {
      setSelectedTab(Number(tab));
    }
  }, [tab, selectedTab]);

  useEffect(() => {
    if (selectedTab) {
      router(`/admin?tab=${selectedTab}`);
    }
  }, [selectedTab, router]);

  return (
    <Grid container direction="column" p="32px 40px" gap="30px">
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h1">Admin</Typography>
        <Grid>
          <Button
            startIcon={<Add />}
            variant="contained"
            sx={{ color: '#FFF', backgroundColor: '#326295' }}
            onClick={() => {
              dispatch(set_create_user_drawer(true));
            }}>
            Add User
          </Button>
        </Grid>
      </Grid>

      <Grid>
        <UserTable />
        <CreateUser />
        <EditUser />
        <DeleteUser />
        <UserDetails />
      </Grid>
    </Grid>
  );
};

export default Admin;
